import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";

const TimezoneClock = ({ timezone, is24Hour }) => {
  const [time, setTime] = useState("");
  const [utcOffset, setUtcOffset] = useState("");

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();

      // Tid i vald tidszon
      const formattedTime = new Intl.DateTimeFormat("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: timezone,
        hour12: !is24Hour,
      }).format(now);

      // Beräkna UTC offset
      const utcString = now.toLocaleString("en-US", { timeZone: "UTC" });
      const tzString = now.toLocaleString("en-US", { timeZone: timezone });

      const diffMs = new Date(tzString) - new Date(utcString);
      const diffHours = diffMs / (1000 * 60 * 60);
      const sign = diffHours >= 0 ? "+" : "-";
      const absHours = Math.floor(Math.abs(diffHours));
      const absMinutes = Math.round((Math.abs(diffHours) % 1) * 60);
      const offset = `UTC${sign}${absHours
        .toString()
        .padStart(2, "0")}:${absMinutes.toString().padStart(2, "0")}`;

      setTime(formattedTime);
      setUtcOffset(offset);
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, [timezone, is24Hour]);

  return (
    <Typography variant="caption" align="center">
      {time} ({utcOffset})
    </Typography>
  );
};

export default TimezoneClock;
